module.exports = __webpack_public_path__ + "2458c1ed255ece6c0610c707e8178e9f.svg";